import React from 'react';
import PhoneLoginModal from './PhoneLoginModal';
import OTPVerificationModal from './OTPVerificationModal';
import WhatsAppConnectionModal from './WhatsAppConnectionModal';
import ProfileCompletionModal from './ProfileCompletionModal';

const AuthModal = ({
  authStep,
  setAuthStep,
  loginMethod,
  setLoginMethod,
  mobile,
  setMobile,
  whatsAppNumber,
  setWhatsAppNumber,
  sendOTP,
  sendOTPForLogin,
  otp,
  handleOtpChange,
  handleOtpKeyDown,
  otpMethod,
  timer,
  canResend,
  resendOTP,
  verifyOTP,
  password,
  checkPasswordStrength,
  passwordStrength,
  showPassword,
  setShowPassword,
  handleEmailLogin,
  rememberMe,
  setRememberMe,
  handleSocialLogin,
  biometricEnabled,
  handleBiometricLogin,
  connectWhatsApp,
  skipWhatsApp,
  userProfile,
  setUserProfile,
  handleProfilePicUpload,
  searchAddress,
  addressSuggestions,
  showAddressSuggestions,
  selectAddress,
  setShowTwoFactorSetup,
  twoFactorEnabled,
  biometricAvailable,
  enableBiometric,
  handleProfileSubmit,
  showForgotPassword,
  showSignUp
}) => {
  
  // Phone Login Screen
  if (authStep === 'phone') {
    return (
      <PhoneLoginModal
        mobile={mobile}
        setMobile={setMobile}
        password={password}
        checkPasswordStrength={checkPasswordStrength}
        passwordStrength={passwordStrength}
        showPassword={showPassword}
        setShowPassword={setShowPassword}
        sendOTPForLogin={sendOTPForLogin}
        sendOTP={sendOTP}
        loginMethod={loginMethod}
        setLoginMethod={setLoginMethod}
        handleEmailLogin={handleEmailLogin}
        rememberMe={rememberMe}
        setRememberMe={setRememberMe}
        handleSocialLogin={handleSocialLogin}
        biometricEnabled={biometricEnabled}
        handleBiometricLogin={handleBiometricLogin}
        showForgotPassword={showForgotPassword}
        showSignUp={showSignUp}
      />
    );
  }

  // OTP Verification Screen
  if (authStep === 'otp') {
    return (
      <OTPVerificationModal
        mobile={mobile}
        otp={otp}
        handleOtpChange={handleOtpChange}
        handleOtpKeyDown={handleOtpKeyDown}
        otpMethod={otpMethod}
        timer={timer}
        canResend={canResend}
        resendOTP={resendOTP}
        verifyOTP={verifyOTP}
        setAuthStep={setAuthStep}
        userProfile={userProfile} 
        setUserProfile={setUserProfile}       
      />
    );
  }

  // WhatsApp Connection Screen
  if (authStep === 'whatsapp') {
    return (
      <WhatsAppConnectionModal
        userProfile={userProfile}
        setUserProfile={setUserProfile}
        mobile={mobile}
        whatsAppNumber={whatsAppNumber}
        setWhatsAppNumber={setWhatsAppNumber}
        connectWhatsApp={connectWhatsApp}
        skipWhatsApp={skipWhatsApp}
      />    
    );
  }

  // Profile Completion Screen
  if (authStep === 'profile') {
    return (
      <ProfileCompletionModal
        userProfile={userProfile}
        setUserProfile={setUserProfile}
        handleProfilePicUpload={handleProfilePicUpload}
        searchAddress={searchAddress}
        addressSuggestions={addressSuggestions}
        showAddressSuggestions={showAddressSuggestions}
        selectAddress={selectAddress}
        setShowTwoFactorSetup={setShowTwoFactorSetup}
        twoFactorEnabled={twoFactorEnabled}
        biometricAvailable={biometricAvailable}
        biometricEnabled={biometricEnabled}
        enableBiometric={enableBiometric}
        handleProfileSubmit={handleProfileSubmit}
      />
    );
  }

  return null;
};

export default AuthModal;